import { useEffect } from 'react';

import { useReactFlow } from '@xyflow/react';
import { useRecordContext } from 'react-admin';

import type { FlowChartData } from '../dataProvider/types';

export interface LocalStorageFlowData {
  data: FlowChartData;
  timestamp: number;
}

// Autosave hook
const useAutoSave = (id: string | undefined, recordChanged: boolean): void => {
  const { getNodes, getEdges } = useReactFlow();
  const flowchartRecord = useRecordContext();

  useEffect(() => {
    // Don't autosave if it's a backup
    if (flowchartRecord?.is_backup === true) return;

    // Update the number to change the autosave frequency
    const saveFrequency = 30000; // 30 seconds

    const saveData = (): void => {
      const nodes = getNodes();
      const edges = getEdges();
      if (!recordChanged || id === undefined || nodes.length === 0 || edges.length === 0) return;
      const timestamp = Date.now();
      const dataToSave: LocalStorageFlowData = {
        timestamp,
        data: {
          nodes,
          edges,
        },
      };
      localStorage.setItem(`flowData-${id}`, JSON.stringify(dataToSave));
    };

    saveData();

    const interval = setInterval(() => {
      saveData();
    }, saveFrequency);

    return () => {
      clearInterval(interval);
    };
  }, [recordChanged, id, getEdges, getNodes, flowchartRecord]);
};

export default useAutoSave;
